<template>
	<div class="login_container">
		<div class="login_box">
			<!--登录框头部-->
			<div class='title_container'>
				<img src="../assets/icon.png" />
				<div class='login_title'> 五微智慧党建平台</div>
			</div>
			<!--登录表单区域-->
			<el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form"
				@keyup.enter.native="login">
				<!--用户名-->
				<el-form-item prop="username">
					<el-input v-model="loginForm.username" prefix-icon="el-icon-s-custom" placeholder="请输入工号/学号">
					</el-input>
				</el-form-item>
				<!--密码-->
				<el-form-item prop="password">
					<el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password"
						placeholder="请输入密码"></el-input>
				</el-form-item>
				<!--按钮-->
				<el-form-item class="btns">
					<el-button type="primary" @click="login"><span class="empty">登</span>录</el-button>
					<el-button type="info" @click="resetLoginForm">重置</el-button>
				</el-form-item>
			</el-form>
			<!--用户注册按钮-->
			<div class="login_resgin">
				<el-button @click="adduserDialogVisible = true">用户注册</el-button>
			</div>
		</div>
		<div class="footer">
			信息工程学院 五微智慧党建平台<br> Copyright &copy; 2023 台州科技职业学院
		</div>
		<el-dialog title="用户注册" :visible.sync="adduserDialogVisible" width="30%" class="adduserdialog" :lock-scroll="true"
			@close="resetadduserForm()">
			<div style="height:500px;" class="scrollbar">
				<el-scrollbar style="height:100%" wrap-style="overflow-x:hidden;">
					<el-form :model="adduserForm" :rules="adduserFormRules" ref="adduserFormRef" label-width="100px"
						label-position="left" required>

						<el-form-item label="工号/学号：" prop="username">
							<el-col :span="18">
								<el-input v-model="adduserForm.username"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="密码：" prop="password">
							<el-col :span="18">
								<el-input v-model="adduserForm.password" type="password" placeholder="请输入密码"></el-input>
								<div class="intensity">
									<span class="psdText">密码强度</span>
									<span class="line" :class="[level.includes('low') ? 'low' : '']"></span>
									<span class="line" :class="[level.includes('middle') ? 'middle' : '']"></span>
									<span class="line" :class="[level.includes('high') ? 'high' : '']"></span>
									<div class="warningtext">
										密码应由8-16位数字、字母、符号组成。
									</div>
								</div>

							</el-col>
						</el-form-item>
						<el-form-item label="确认密码：" prop="repassword">
							<el-col :span="18">
								<el-input v-model="adduserForm.repassword" type="password"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="姓名：" prop="fullName">
							<el-col :span="18">
								<el-input v-model="adduserForm.fullName"></el-input>
							</el-col>
						</el-form-item>

						<el-form-item label="性别：" prop="sex">
							<el-col :span="18">
								<el-select v-model="adduserForm.sex" placeholder="请选择">
									<el-option v-for="item in sex" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="班级：" prop="banji">
							<el-col :span="18">
								<el-input v-model="adduserForm.banji" placeholder="例如:计应21-1"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="手机号码：" prop="mobile">
							<el-col :span="18">
								<el-input v-model="adduserForm.mobile"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="身份证号码" prop="identity">
							<el-col :span="18">
								<el-input v-model="adduserForm.identity"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="出生年月：" prop="birth">
							<el-date-picker v-model="adduserForm.birth" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" placeholder="选择出生日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="民族：" prop="minzu">
							<el-col :span="18">
								<el-input v-model="adduserForm.minzu" placeholder="例如：汉族"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="籍贯:" prop="jiguan">
							<el-col :span="15">
								<el-input v-model="adduserForm.jiguan" placeholder="例如：浙江台州"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="户籍所在地:" prop="hujidizhi">
							<el-col :span="20">
								<el-input v-model="adduserForm.hujidizhi" placeholder="请输入身份证上的地址"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="现居地:" prop="juzhudizhi">
							<el-col :span="20">
								<el-input v-model="adduserForm.juzhudizhi" placeholder="请输入目前居住的家庭地址"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-button @click="adduserDialogVisible = false">取 消</el-button>
							<el-button type="warning" @click="resignUser()">确 定</el-button>
						</el-form-item>
					</el-form>
				</el-scrollbar>


			</div>
		</el-dialog>

	</div>
</template>

<script>

import axios from "axios";
import {
	setAuth,
	setToken
} from "@/utils/auth.js";

import { addUser } from "../utils/api"
// Vue.prototype.$axios = Axios;

export default {
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (this.level.length == 3) {
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.adduserForm.password) {
					this.$message.error("两次输入密码不一致，请重新输入");
				} else {
					callback();
				}
			} else {
				this.$message.error("请设置强密码");

			}
		};
		return {
			//注册时性别选项
			sex: [
				{
					value: '',
					label: '请选择'
				},
				{
					value: '男',
					label: '男'
				},
				{
					value: '女',
					label: '女'
				},

			],
			loginForm: {
				username: '',
				password: ''
			},
			level: [],
			loginFormRules: {
				//验证用户名是否合法
				username: [{
					required: true, message: "请输入正确的工号/学号"
				},
				{ min: 10, max: 10, message: "长度为10个字符" }
				],
				password: [
					{ required: true, message: "请输入密码" },
					{ min: 3, max: 15, message: "长度在3-15个字符之间" }
				]
			},
			//验证注册列表的必要性
			adduserFormRules: {
				username: [
					{ required: true, message: "请输入正确的工号/学号" },
					{ min: 10, max: 10, message: "长度为10个字符" }
				],
				password: [{
					required: true, message: "请输入密码", validator: this.checkPassword, trigger: 'change'
				}],
				repassword: [{
					required: true, message: "请再次输入密码", validator: validatePass2, trigger: 'blur'
				}],
				fullName: [{
					required: true, message: "请输入姓名"
				}],
				sex: [{
					required: true, message: "请输入性别"
				}],
				banji: [{
					required: true, message: "请输入班级"
				}],
				minzu: [{
					required: true, message: "请输入名族"
				}],
				jiguan: [{
					required: true, message: "请输入籍贯"
				}],
				mobile: [
					{ required: true, message: "请输入手机号码" },
					{ min: 11, max: 11, message: "请输入正确的11位手机号码" }
				],
				birth: [{
					required: true, message: "请输入出生年月"
				}],
				identity: [
					{ required: true, message: "请输入身份证号码" },
					{ min: 18, max: 18, message: "请输入正确的18位身份证号码" }
				],
				hujidizhi: [{
					required: true, message: "请输入户籍所在地"
				}],
				juzhudizhi: [{
					required: true, message: "请输入家庭地址"
				}],

			},


			//控制用户注册对话框的显示与隐藏
			adduserDialogVisible: false,
			//用户注册对话框
			adduserForm: {
				username: '',
				password: '',
				fullName: '',
				sex: '',
				banji: '',
				minzu: '',
				jiguan: '',
				mobile: '',
				birth: '',
				identity: '',
				hujidizhi: '',
				juzhudizhi: ''

			},
		}
	},
	methods: {
		//点击重置按钮，重置登录表单
		resetLoginForm() {
			this.$refs.loginFormRef.resetFields();

		},
		//关闭注册用户窗口，重置表单
		resetadduserForm() {
			this.$refs.adduserFormRef.resetFields();

		},

		login(username, password) {
			let baseUrl = "http://36.134.183.225:9898";
			axios
				.post(baseUrl + "/login", this.loginForm)
				.then((response) => {
					let data = response.data;
					if (data.code == '0000') {
						setToken(data.data.token_type + " " + data.data.access_token);
						this.$router.push({ path: '/welcome' });
					} else {
						console.log(data)
					}
				})
				.catch((error) => {
					if (error.response.status === 403) {
						this.$message.error(error.response.data.data);

					} else {
						// uni.showToast({
						// 	title: error.message
						// });
					}
				})
				.finally(() => { });
		},
		resignUser() {
			this.adduserDialogVisible = false;
			addUser(this.adduserForm).then(result => {
				console.log(result);
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.$refs.adduserFormRef.resetFields();

				} else {
					this.$message("注册失败,用户已存在或注册信息不完整");
					this.$refs.adduserFormRef.resetFields();
				}
			})
		},
		// 校验密码
		checkPassword(rule, value, callback) {
			this.level = []
			console.log(value);
			console.log(this.level);
			if (!value) {
				return callback('密码不能为空')
			}
			if (value.length < 8) {
				return callback('密码不少于8位')
			}
			if (value.length > 16) {
				return callback('密码不大于16位')
			}
			// 校验是数字
			const regex1 = /^\d+$/
			// 校验字母
			const regex2 = /^[A-Za-z]+$/
			// 校验符号
			const regex3 = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/
			if (regex1.test(value)) {
				this.level.push('low')
			} else if (regex2.test(value)) {
				this.level.push('low')
			} else if (regex3.test(value)) {
				this.level.push('low')
			} else if (/^[A-Za-z\d]+$/.test(value)) {
				this.level.push('low')
				this.level.push('middle')
			} else if (
				/^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\d]+$/.test(
					value
				)
			) {
				this.level.push('low')
				this.level.push('middle')
			} else if (
				/^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z]+$/.test(
					value
				)
			) {
				this.level.push('low')
				this.level.push('middle')
			} else if (
				/^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z\d]+$/.test(
					value
				)
			) {
				this.level.push('low')
				this.level.push('middle')
				this.level.push('high')
				console.log('aaaa');
			}
			return callback()
		},

	},
	mounted: function () {

	}


}
</script>

<style lang="less">
.login_container {
	padding: 20px;
	font-size: 14px;
	background-image: url('../assets/bg2.jpg');
	height: 880px;
	background-size: 100%;
	background-repeat: no-repeat;
}

.login_box {
	width: 520px;
	height: 570px;
	background-color: #fff;
	border-radius: 10px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	opacity: 0.8;
	//  box-shadow: 10px 10px 100px #979191;
}

.title_container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
}

.title_container img {
	width: 80px;
}


.login_title {
	font-size: 39px;
	text-align: center;
	color: #000;
	margin: 50px 0;
	text-align: center;
	font-weight: 600;
	font-family: 'STXihei';
}

.login_form {
	width: 80%;
	padding: 0 30px;
	box-sizing: border-box;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.btns {
	margin-top: 50px;
	display: flex;
	justify-content: space-around;

}


.login_form .el-button--primary {
	width: 140px;
	background-color: #f39c12;
	border: none;
	font-size: 18px;
}

.login_form .el-button--info {
	width: 140px;
	// margin-left: 100px;
	font-size: 18px;
	background-color: #676663;

}

/deep/.login_form .el-form-item_label {
	text-align: left;
}

.login_form .el-button--primary:focus,
.login_form .el-button--primary:hover {
	background: #e67e22;
	border-color: #e67e22;
}

.login_form .el-button--info:focus,
.login_form .el-button--info:hover {
	background: red;
	border-color: red;
}

.login_form .el-form-item__error {
	color: #d93f3d;
}

// .el-input.is-active .el-input__inner, .el-input__inner:focus
.login_form .el-input__inner:focus {
	border-color: #0a0519;
}

.login_resgin {
	position: fixed;
	bottom: 100px;
	right: 100px;
	border-color: none;
	font-size: 18px;
}

.resetadduserForm .el-form-item_label {
	font-size: 18px;
	color: red;
}

.login_container .el-dialog__header {
	border-bottom: 1px solid #e8eaec !important;
	background: #fcf1e7 !important;
	color: #fff !important;
}

.footer {
	position: fixed;
	bottom: 8px;
	left: 0px;
	height: 70px;
	width: 100%;
	text-align: center;
	color: #e67e22;
	font-size: 18px;
}

//强密码设置
.intensity {
	.psdText {
		font-size: 14px;
		margin-right: 10px;
	}

	.line {
		display: inline-block;
		width: 48px;
		height: 4px;
		background: #d8d8d8;
		border-radius: 3px;
		margin-right: 8px;

		&.low {
			background: #f4664a;
		}

		&.middle {
			background: #ffb700;
		}

		&.high {
			background: #2cbb79;
		}
	}

	.level {
		margin: 0 16px 0 8px;
	}

	.warningtext {
		color: red;
		font-size: 12px;
		margin-top: 5px;
	}
}
</style> 

